<template>
  <div>
    <v-dialog :model-value="show" @update:model-value="$emit('update:modelValue', $event)" max-width="1200px">
      <v-card>
        <v-card-title>Execution History</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            item-key="id"
            density="compact"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-chip :color="item.status === 'success' ? 'green' : 'red'" size="small">{{ item.status }}</v-chip>
            </template>
            <template v-slot:[`item.executedAt`]="{ item }">
              {{ new Date(item.executedAt).toLocaleString() }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn v-if="item.response" size="small" @click="showResult(item)">See Result</v-btn>
            </template>
            <template v-slot:[`item.error`]="{ item }">
              {{ item.error || 'N/A' }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('update:modelValue', false)">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showResultDialog" max-width="900px">
      <v-card>
        <v-card-title>
          Run Result - {{ selectedResult ? new Date(selectedResult.executedAt).toLocaleString() : '' }}
        </v-card-title>
        <v-card-text class="result-dialog-text">
          <FormattingCard :content="selectedResult ? selectedResult.response : ''" :expanded="'true'" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showResultDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import { ScheduledRunResult } from '@/types/schedules';
import FormattingCard from '@/components/cards/FormattingCard.vue';

@Options({
  props: {
    runId: String,
    show: Boolean,
  },
  components: {
    FormattingCard,
  },
  computed: {
    ...mapGetters(['getResultsByRunId']),
  },
  emits: ['update:modelValue'],
  watch: {
    show(isVisible: boolean) {
      if (isVisible && this.runId) {
        this.loadResults();
      }
    }
  }
})
export default class ScheduledRunHistoryDialog extends Vue {
  runId!: string;
  show!: boolean;

  getResultsByRunId!: (runId: string) => { items: ScheduledRunResult[], total: number } | undefined;
  
  loading = false;
  showResultDialog = false;
  selectedResult: ScheduledRunResult | null = null;
  headers = [
    { title: 'Executed At', key: 'executedAt', width: '20%' },
    { title: 'Status', key: 'status', width: '10%' },
    { title: 'Actions', key: 'actions', sortable: false, width: '20%' },
    { title: 'Error', key: 'error', width: '50%' },
  ];

  get results() {
    return this.getResultsByRunId(this.runId)?.items || [];
  }

  async loadResults() {
    console.log('Loading results for run:', this.runId); // Debug log
    this.loading = true;
    await this.$store.dispatch('fetchRunResults', { runId: this.runId });
    this.loading = false;
  }

  showResult(item: ScheduledRunResult) {
    this.selectedResult = item;
    this.showResultDialog = true;
  }
}
</script>

<style scoped>
.result-dialog-text {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
